import script from "./AdminLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminLayout.vue?vue&type=script&setup=true&lang=js"

import "./AdminLayout.vue?vue&type=style&index=0&id=49dcd6d7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49dcd6d7"]])

export default __exports__